<template>
  <div class="" v-if="Object.keys(product).length > 0">

    <p><span v-t="`product.view_count.view_count_label`"></span> {{ getProductViewCount() }}</p>
  </div>
</template>

<script>

export default {
  name: "ProductViewCount1",
  props: {
    product: {}
  },
  methods: {
    getProductViewCount() {
      let productMeta = this.product.meta
      if (productMeta != undefined) {
        let viewCount = productMeta.find((item) => {
          return item.name === 'view_count';
        });
        return viewCount == undefined ? null : viewCount.value
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>